import {
  COLOR,
  mq,
  FONT_SIZE,
  FONT_WEIGHT,
  Button as _Button,
  TextLink as _TextLink,
} from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivGridContainer = styled.div`
  display: grid;
  grid-gap: 32px;
`;

export const DivTextWrapper = styled.div`
  display: grid;
  grid-gap: 8px;
  padding-right: 48px;
`;

export const ParSubText = styled.p`
  color: ${COLOR.GRAY900.code};

  ${mq.sp} {
    font-size: 14px;
  }
`;

export const ParRedText = styled.p`
  display: inline-block;
  color: ${COLOR.RED900.code};
  font-weight: ${FONT_WEIGHT.BOLD};
  padding-right: 4px;
`;

export const SpanWhiteText = styled.span`
  display: inline-block;
  font-weight: ${FONT_WEIGHT.BOLD};
`;

export const DivInputFlex = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const DivMarginRight = styled.div`
  margin-right: 16px;

  ${mq.sp} {
    margin-right: 8px;
  }
`;

export const DivGridInputNameWrapper = styled.div`
  display: grid;
  grid-gap: 8px;
  width: 50%;
`;

export const DivGridInputWrapper = styled.div`
  display: grid;
  grid-gap: 8px;
`;

export const Label = styled.label`
  width: fit-content;

  ${mq.sp} {
    font-size: 14px;
  }
`;

export const SpanMandatory = styled.span`
  color: ${COLOR.ERROR.code};
`;

export const DivTextLinkCenter = styled.div`
  display: flex;
  justify-content: center;
`;

export const DivBottomButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Button = styled(_Button)`
  font-size: 16px;
  width: 320px;

  ${mq.sp} {
    font-size: 14px;
    width: 100%;
  }
`;

export const TextLink = styled(_TextLink)`
  font-size: ${FONT_SIZE.M}px;

  ${mq.sp} {
    font-size: ${FONT_SIZE.S}px;
  }
`;
